import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LinkContent } from "./LinkDataInterface";
import styled from "styled-components";

export function LinkButton({ item }: { item: LinkContent }) {
  function handleClick() {
    window.open(item.link)?.focus();
  }

  return (
    <Button
      onClick={handleClick}
      $color={item.color}
      $text={item.text}
      $hover={item.hover}
      $textHover={item.textHover}
    >
      <Icon>
        <FontAwesomeIcon icon={item.faLogo} size="2xl" />
      </Icon>

      <Title>{item.title}</Title>
    </Button>
  );
}

const Icon = styled.div`
  height: auto;
  width: 50px;
`;

const Title = styled.p`
  width: 100%;
  height: auto;
  justify-content: left;
`;

const Button = styled.button<{
  $color?: string;
  $text?: string;
  $hover?: string;
  $textHover?: string;
}>`
  display: flex;
  height: 50px;
  width: 100%;
  display: flex;
  margin: 0%;
  margin-bottom: 10px;
  padding: 2%;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.$color};
  color: ${(props) => props.$text};
  border-style: none;
  &:hover {
    background-color: ${(props) => props.$hover};
    color: ${(props) => props.$textHover};
  }
  border-radius: 10px;
`;
